import { Link } from 'react-router-dom';
import { CONTACT } from '../../config/contact';
import { FOOTER, SERVICES } from '../../content/site';
import Logo from '../Logo/Logo';
import styles from './Footer.module.css';

const YEAR = new Date().getFullYear();

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.brandCol}>
          <Link to="/" className={styles.brand} aria-label="Summerlin — home">
            <Logo size="lg" />
          </Link>
          <p>{FOOTER.summary}</p>
        </div>

        <div className={styles.col}>
          <h4>Site</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/#services">Services</Link></li>
            <li><Link to="/#approach">Approach</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        <div className={styles.col}>
          <h4>Services</h4>
          <ul>
            {SERVICES.map((service) => (
              <li key={service.slug}>
                <Link to={`/#${service.slug}`}>{service.short}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className={styles.col}>
          <h4>{CONTACT.company}</h4>
          <address>
            {CONTACT.addressLines.map((line) => (
              <span key={line}>{line}</span>
            ))}
            <a href={CONTACT.phoneHref}>{CONTACT.phoneDisplay}</a>
          </address>
        </div>
      </div>

      <div className={styles.bottom}>
        <span>© {YEAR} {CONTACT.company} All rights reserved.</span>
        <span>{FOOTER.disciplines}</span>
      </div>
    </footer>
  );
};

export default Footer;
